module.exports = __webpack_public_path__ + "static/media/empty-state-right-arrow.af6a287a.svg";